import { getSettings } from '@juvare/platform-sdk-react/ui/features/editable-settings';
import { useSelector } from 'react-redux';
export const useSystemRoles = () => {
    const { systemRoleMap } = useSelector(getSettings);
    return {
        systemRoleLabels: Object.entries(systemRoleMap).reduce((acc, [name, value]) => {
            acc[name] = value.label;
            return acc;
        }, {}),
    };
};
